export const mutations = {
  addTripIncome(state) {
    state.trip_income.push({
      description: "",
      unit_price: "",
      total: ""
    });
  },
  STORE_TRIPS(state, trips) {
    state.trips = trips;
  },
  STORE_TRIP_UPDATE(state, tripId) {
    let Trip = state.trips.find(function(trip) {
      return trip.id === tripId;
    });
    state.systemTrip = Trip;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/mutations.js